import { render } from "./ConfirmBtn.vue?vue&type=template&id=4f1f95d5&scoped=true"
import script from "./ConfirmBtn.vue?vue&type=script&lang=js"
export * from "./ConfirmBtn.vue?vue&type=script&lang=js"

import "./ConfirmBtn.vue?vue&type=style&index=0&id=4f1f95d5&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1f95d5"]])

export default __exports__